import React from "react"
import { useModal } from "../../../../../../../hooks/ModalContext"
import { useChatWhatsApp } from "../../../../../../../context/ChatWhatsAppContext"
import { useHibrido } from "../../../../../../../context/HibridoContext"
import { useDividas } from "../../../../../../../context/DividasContext"

export const StartButton = () => {
  const { chatIdHibrido } = useChatWhatsApp()
  const { dadosChamada } = useHibrido()
  const { devedorCadastro } = useDividas()
  const { setModal } = useModal()
  async function handleCreateChat() {
    setModal('Chat Contato', 'Chat Contato', false, false)
  }
  return (
    <>
      {
        !chatIdHibrido && devedorCadastro && devedorCadastro?.cpfcnpj && <button type="button" className="bg-white flex p-4 w-[99%] h-10 justify-center items-center  text-primary font-semibold rounded-md" onClick={() => handleCreateChat()}>Iniciar conversa</button>
      }
    </>

  )
}